/* beurer.co.za header (4.1, 24 Oct 2026): spread "Customer service · Company · Magazine" so the first word
   starts under the promo text ("Free delivery over R650 …") and "Magazine" ends under the basket.
   Desktop only; recalculates on resize. */
(function () {
  function textEdges(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, l = Infinity, r = -Infinity;
    while ((n = w.nextNode())) {
      if (!n.textContent.trim()) continue;
      var range = document.createRange(); range.selectNodeContents(n);
      var b = range.getBoundingClientRect();
      if (b.width) { l = Math.min(l, b.left); r = Math.max(r, b.right); }
    }
    return l === Infinity ? null : { left: l, right: r };
  }
  function align() {
    var menu = document.querySelector('.site-navigation__secondary-menu');
    var promo = document.querySelector('.small-promo');
    var cart = document.querySelector('.site-header-cart svg') || document.querySelector('.site-header-cart');
    if (!menu) return;
    menu.style.width = ''; menu.style.marginRight = ''; menu.style.justifyContent = '';
    if (!promo || !cart || window.innerWidth < 1024 || !promo.offsetParent || !menu.offsetParent) return;
    var links = menu.querySelectorAll(':scope > li > a');
    if (links.length < 2) return;
    var p = textEdges(promo), first = textEdges(links[0]), last = textEdges(links[links.length - 1]);
    if (!p || !first || !last) return;
    var target = { left: p.left, right: cart.getBoundingClientRect().right };
    var box = menu.getBoundingClientRect();
    var padL = first.left - box.left, padR = box.right - last.right;
    var width = (target.right - target.left) + padL + padR;
    if (width < (last.right - first.left) + padL + padR) return;
    var mr = parseFloat(getComputedStyle(menu).marginRight) || 0;
    menu.style.width = width + 'px';
    menu.style.justifyContent = 'space-between';
    menu.style.marginRight = (mr + (box.right - (target.right + padR))) + 'px';
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(align, 120); });
  if (document.readyState === 'complete') align(); else window.addEventListener('load', align);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
})();
